module.exports = __webpack_public_path__ + "media/text2_img_2.9fe922e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/text2_img_2.png
// module id = 675
// module chunks = 2